module.exports = __webpack_public_path__ + "static/media/underwear-female-set.79c0738f.svg";